import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

import { Content } from './content/content'

export interface SetAlertsDialogProps {
  open: boolean
  isEoir?: boolean
  onClose: VoidFunction
}

export const SetAlertsDialog = ({ open, isEoir = false, onClose }: SetAlertsDialogProps) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Set Other Alerts</DialogTitle>
          <DialogDescription className={cn('sr-only')}>
            You can set alerts to receive email notifications.
          </DialogDescription>
        </DialogHeader>

        <Content isEoir={isEoir} closeDialog={onClose} />
      </DialogContent>
    </Dialog>
  )
}
